// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-input--invalid .dropdown__header{border-color:#ff7f7f}`, "",{"version":3,"sources":["webpack://./src/components/Form/Typeahead/style.scss","webpack://./src/style/variables.scss"],"names":[],"mappings":"AAGI,uCACE,oBCiHA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
